import React, { Component } from 'react';
import UserTable from './userTable';
import { withRouter, NavLink } from 'react-router-dom';
import * as userActions from '../../redux/users/actions';
import * as contractActions from '../../redux/contract/actions';
import UserFilters from './userFilters';
import { connect } from 'react-redux';
import Spin from '../../components/loading';
import Pagination2 from '../../components/Pagination2';
import submitForm from '../../utils/submitForm';
import AlertAndConfirmation from '../../utils/AlertAndConfirmation';

class UserManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usersList: [],
      errorText: locales('errors.default'),
      errorFlag: false,
      sortType: 'asc',
      sortBy: 'createdAt',
      currentPage: 1,
      itemsPerPage: 10,
    };
  }

  componentDidMount() {
    let localQuery = sessionStorage.getItem('query');
    if (localQuery) {
      this.setState({ filter: localQuery }, () => this.filterAndSort());
    }
    this.sortTable(this.state.sortBy);
  }

  componentWillMount() {
    this.props.getCitiesContract();
  }

  handleAlert = () => {
    AlertAndConfirmation({ text: this.state.errorText, type: 'error' });
    this.setState({ errorFlag: false });
  };

  filterAndSort = () => {
    let { filter, sort } = this.state;
    let query;
    if (sort && filter) query = `${filter}&${sort}`;
    else if (filter) query = `${filter}`;
    else if (sort) query = `${sort}`;
    this.setState({ query, currentPage: 1 }, () => {
      let searchQuery = this.buildSearchQuery(
        this.state.currentPage,
        this.state.itemsPerPage,
      );
      this.props.fetchUsers(searchQuery);
    });
  };

  applyFilters = event => {
    const queryString = submitForm(
      event,
      this.state.selectedRegions,
      this.state.selectedAmenities,
    );
    sessionStorage.setItem('query', queryString);
    this.setState({ filter: queryString }, () => this.filterAndSort());
  };
  sortTable = query => {
    this.setState(
      { sortType: this.state.sortType == 'asc' ? 'desc' : 'asc' },
      () => {
        query = `${query}-${this.state.sortType}`;
        this.setState({ sort: `sort=${query}` }, () => this.filterAndSort());
      },
    );
  };

  buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${this.state.query || 'sort=createdAt-desc'}`;
      return query;
    }
  };

  onPageChanged = data => {
    const { currentPage, totalPages, pageLimit } = data;
    this.setState({ currentPage: currentPage }, () => {
      const query = this.buildSearchQuery(
        this.state.currentPage,
        this.state.itemsPerPage,
      );
      this.props.fetchUsers(query);
    });
  };
  render() {
    let { totalRecords, pageNumber, pageSize } = this.props.users;
    let { loading, message, failed, error } = this.props;
    let { sortType, currentPage, itemsPerPage } = this.state;
    return (
      <React.Fragment>
        {this.state.errorFlag && this.handleAlert()}
        <section className={`p-1 col-12`}>
          <div className='col-12 d-flex justify-content-between align-items-center'>
            <h3 className='text-right text-muted py-4'>
              {locales('titles.usersManagement')}
            </h3>
            <div>
              <NavLink
                to={{
                  pathname: '/users/add',
                  editMode: false,
                }}
              >
                <button className='btn btn-primary w-5 mx-1'>
                  <i className='fal fa-plus mx-1' />
                  {locales('labels.addNewUser')}
                </button>
                {/* </ShowForPermission> */}
              </NavLink>
            </div>
          </div>
          <Spin spinning={loading}>
            <article>
              <main className='panel panel-default'>
                {error ? (
                  <div className='alert alert-danger'>
                    {locales('messages.server.error')}
                  </div>
                ) : (
                  <>
                    {failed && (
                      <div className='alert alert-danger'>{message}</div>
                    )}
                    <div className='panel-heading'>
                      <i className='fas fa-list-alt px-1' />
                      {locales('titles.usersList')}
                    </div>
                    <div className='panel-body'>
                      <UserFilters
                        applyFilters={this.applyFilters}
                        filterAndSort={this.filterAndSort}
                        cities={this.props.cities}
                      />
                      <UserTable
                        sortType={sortType}
                        pageNumber={currentPage}
                        pageSize={itemsPerPage}
                        sortTable={this.sortTable}
                      />
                      <footer className='col-12 d-flex justify-content-center py-2'>
                        <div className='pagination-container'>
                          <Pagination2
                            totalRecords={totalRecords || 0}
                            pageLimit={itemsPerPage}
                            pageNeighbours={2}
                            onPageChanged={this.onPageChanged}
                            currentPage={this.state.currentPage}
                          />
                        </div>
                      </footer>
                    </div>
                  </>
                )}
              </main>
            </article>
          </Spin>
        </section>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchUsers: query => dispatch(userActions.fetchUsers(query)),
    getCitiesContract: () => dispatch(contractActions.getCitiesContract()),
  };
};

const mapStateToProps = (state, props) => {
  return {
    users: state.userReducer.users || {},
    loading: state.userReducer.loading,
    message: state.userReducer.message,
    failed: state.userReducer.failed,
    error: state.userReducer.error,
    cities: state.cafesContractReducer.cities,
  };
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(UserManagement),
);
